import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
export const BUSINESSES_RESTART_REQUEST = 'BUSINESSES_RESTART_REQUEST'
export const BUSINESSES_RESTART_SUCCESS = 'BUSINESSES_RESTART_SUCCESS'
export const BUSINESSES_RESTART_FAILURE = 'BUSINESSES_RESTART_FAILURE'

export const businessRestart = (id) => ({
  [CALL_API]: {
    endpoint: `/api/business/businesses/${id}/run-aml/`,
    types: [BUSINESSES_RESTART_REQUEST, BUSINESSES_RESTART_SUCCESS, BUSINESSES_RESTART_FAILURE],
    method: 'POST',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
